import type { Messages } from "../locales/fr";
import type { InstallUiState } from "./policy";

export function renderInstallCard(state: InstallUiState, t: Messages): string {
  if (state === "off") return "";
  if (state === "available") {
    return `<button type="button" class="general-card" data-act="install"><span class="g-ico" aria-hidden="true">↓</span><strong>${t.install}</strong><span class="g-hint">${t.options.installHint}</span></button>`;
  }
  if (state === "installed") {
    return `<div class="general-card is-note" role="status"><span class="g-ico" aria-hidden="true">✓</span><strong>${t.options.installInstalled}</strong><span class="g-hint">${t.options.installInstalledHint}</span></div>`;
  }
  return `<div class="general-card is-note" role="status"><span class="g-ico" aria-hidden="true">i</span><strong>${t.options.installUnavailable}</strong><span class="g-hint">${t.options.installUnsupported}</span></div>`;
}

export function renderPrivateBetaNotice(pwaEnabled: boolean, notice: string): string {
  if (!pwaEnabled) return "";
  return `<p class="private-beta-note">${notice}</p>`;
}
